import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { ApiContract } from './resources/contracts/contract';
import { ApiContractGE } from './resources/contracts/ge';
import { ApiContractInvoice } from './resources/contracts/invoice';
import { ApiContractLogistic } from './resources/contracts/logistic';
import { ApiContractMisc } from './resources/contracts/misc';
import { ApiContractVolume } from './resources/contracts/volume';
import { ApiCoreCost } from './resources/core/cost';
import { ApiCoreCustomer } from './resources/core/customer';
import { ApiCustomerGE } from './resources/customer/ge';
import { ApiCustomer } from './resources/customer/referential-client';
import { ApiMidback } from './resources/midback/api-version';
import { ApiMidbackBidding } from './resources/midback/bidding';
import { ApiCarbonAccounting } from './resources/midback/carbon-accounting';
import { ApiCertificateOperations } from './resources/midback/certificate-operations';
import { ApiMidbackContract } from './resources/midback/contract';
import { ApiMidbackDreams } from './resources/midback/dreams';
import { ApiEgmaTransaction } from './resources/midback/egma-transaction';
import { ApiLongTermForecast } from './resources/midback/long-term-forecast';
import { ApiMidbackMetering } from './resources/midback/metering';
import { ApiMidbackNetwork } from './resources/midback/network';
import { ApiMidbackNomination } from './resources/midback/nomination';
import { ApiMidbackOrder } from './resources/midback/order';
import { ApiPortalDocument } from './resources/midback/portal-document';
import { ApiMidbackPortalThread } from './resources/midback/portal-thread';
import { ApiMidbackQuote } from './resources/midback/quotes';
import { ApiReferentialGreenProduct } from './resources/midback/referential-green-product';
import { ApiMidbackRole } from './resources/midback/role';
import { ApiSearch } from './resources/midback/search';
import { ApiTaxExoneration } from './resources/midback/tax-exoneration';
import { ApiTeams } from './resources/midback/teams';
import { ApiMidbackThirdPartyReferential } from './resources/midback/third-party-referential';
import { ApiUserCurves } from './resources/midback/user-curves';
import { ApiMidbackVolumes } from './resources/midback/volumes';
import { ApiPortalCustomer } from './resources/portal/customer';
import { ApiPortal } from './resources/portal/portal';
import { ApiRiskModelerEvent } from './resources/risk-modeler/events';
import { ApiSupplyDataBeProfile } from './resources/supply-data/be-profiles';
import { ApiSupplyDataMasterData } from './resources/supply-data/master-data';
import { ApiUserAccessControl } from './resources/user/access-control';
import { ApiUserContact } from './resources/user/contact';
import { ApiVolumeNetwork } from './resources/volumes/network';
import { ApiVolume } from './resources/volumes/volume';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected http = inject(HttpClient);
  // midBack
  midBackApiVersion = new ApiMidback(this.http);
  midBackCarbonAccounting = new ApiCarbonAccounting(this.http);
  midBackBidding = new ApiMidbackBidding(this.http);
  midBackCertificateOperations = new ApiCertificateOperations(this.http);
  midBackContract = new ApiMidbackContract(this.http);
  midBackSearch = new ApiSearch(this.http);
  midBackLongTermForecast = new ApiLongTermForecast(this.http);
  midBackPortalThread = new ApiMidbackPortalThread(this.http);
  midBackMetering = new ApiMidbackMetering(this.http);
  midBackNetwork = new ApiMidbackNetwork(this.http);
  midBackNomination = new ApiMidbackNomination(this.http);
  midBackOrder = new ApiMidbackOrder(this.http);
  midBackDocument = new ApiPortalDocument(this.http);
  midBackQuote = new ApiMidbackQuote(this.http);
  midBackRole = new ApiMidbackRole(this.http);
  midBackTeams = new ApiTeams(this.http);
  midBackThirdPartyReferential = new ApiMidbackThirdPartyReferential(this.http);
  midBackReferentialGreenProduct = new ApiReferentialGreenProduct(this.http);
  midBackTaxExoneration = new ApiTaxExoneration(this.http);
  midBackUserCurves = new ApiUserCurves(this.http);
  midEgmaTransaction = new ApiEgmaTransaction(this.http);
  midBackDreams = new ApiMidbackDreams(this.http);
  midBackVolumes = new ApiMidbackVolumes(this.http);
  // Supply Data
  supplyDataMasterData = new ApiSupplyDataMasterData(this.http);
  supplyDataBeProfile = new ApiSupplyDataBeProfile(this.http);
  // Risk Modeler
  riskModelerEvent = new ApiRiskModelerEvent(this.http);
  // Core
  coreCost = new ApiCoreCost(this.http);
  coreCustomer = new ApiCoreCustomer(this.http);
  // User
  userAccessControl = new ApiUserAccessControl(this.http);
  userContact = new ApiUserContact(this.http);
  // Portal
  portal = new ApiPortal(this.http);
  portalCustomer = new ApiPortalCustomer(this.http);
  // Customer
  customer = new ApiCustomer(this.http);
  customerGE = new ApiCustomerGE(this.http);
  // Volumes
  volumeNetwork = new ApiVolumeNetwork(this.http);
  volume = new ApiVolume(this.http);
  // Contracts
  contractGE = new ApiContractGE(this.http);
  contractLogistic = new ApiContractLogistic(this.http);
  contractMisc = new ApiContractMisc(this.http);
  contractVolume = new ApiContractVolume(this.http);
  contractInvoice = new ApiContractInvoice(this.http);
  contract = new ApiContract(this.http);
}
